export class DigAdTranslationConfig {
  public digAdMetrics: any;
  public digAdLabels: any;
  public digAdReportTitles: any;
  public digAdChartDimensions: any;
  public digAdChannels: any;
}
